import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Text, Button, Flex, Card } from 'rebass';
import momentTimezone from 'moment-timezone';
import SpinLoader from '../../components/SpinLoader';
import PleaseWait from '../../components/PleaseWait';
import { LABS } from '../../graphql';

const OPEN_SLOTS = gql`
  query($startDate: String, $endDate: String, $enforceProviderId: String, $enforceDepartmentId: String, $isMeno: Boolean, $force30: Boolean, $isWeightLoss: Boolean) {
    openAppointments(
      data: { startDate: $startDate, endDate: $endDate }
      enforceProviderId: $enforceProviderId
      enforceDepartmentId: $enforceDepartmentId
      isMeno: $isMeno
      force30: $force30
      isWeightLoss: $isWeightLoss
    ) {
      id
      startTime
      date
      duration
      providerId
      departmentId
      timezoneName
      timezoneLongName
      canWaitlist
    }
  }
`;

const CAN_WAITLIST = gql`
  query canWaitlist($startDate: String, $endDate: String, $enforceProviderId: String, $enforceDepartmentId: String, $isMeno: Boolean, $force30: Boolean, $isWeightLoss: Boolean) {
    canWaitlist(
      data: { startDate: $startDate, endDate: $endDate }
      enforceProviderId: $enforceProviderId
      enforceDepartmentId: $enforceDepartmentId
      isMeno: $isMeno
      force30: $force30
      isWeightLoss: $isWeightLoss
    )
  }
`;

const TimesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
`;

const TimesText = styled.span`
  display: block;
  font-weight: 500;
  text-decoration: underline;
  align-self: flex-end;

  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const TimesIndicatorWeb = styled.div`
  display: block;
  background: #344f79;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 12px;

  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const TimesIndicator = styled.div`
  display: block;
  background: #344f79;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 12px;

  @media screen and (min-width: 52em) {
    display: none;
  }
`;

const DayMobile = styled.div`
  display: block;

  @media screen and (min-width: 52em) {
    display: none;
  }
`;

const DayFull = styled.span`
  display: block;

  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const AvailabilitiesLoadingErrorWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const AvailabilitiesLoadingErrorText = styled.div`
  margin-top: 20px;
  font-weight: 500;
  &.error {
    color: #f9a394;
  }
  &.title {
    font-weight: 700;
  }
`;

const ExpandedRow = styled.div`
  padding: 20px;
  border-width: 2px 0;
  border-color: #4467e2;
  border-style: solid;
  position: relative;
`;

const SlotButton = styled(Button)`
  margin: 6px;
  width: auto;
  border-width: 1px;
  font-size: 14px;
`;

class CalendarGrid extends React.Component {
  constructor(props) {
    super(props);
    const { reschedulingAppointment, nextAppointmentAvailable } = this.props;
    // console.log('nextAppointmentAvailable', nextAppointmentAvailable)
    this.state = {
      currentMonth:
        reschedulingAppointment && reschedulingAppointment.date
          ? moment(`${reschedulingAppointment.date} ${reschedulingAppointment.startTime}`, 'MM/DD/YYYY HH:mm')
          : nextAppointmentAvailable && nextAppointmentAvailable.length > 0
            ? moment(nextAppointmentAvailable[0].date, 'MM/DD/YYYY')
            : new Date(),
      selectedDate: reschedulingAppointment && reschedulingAppointment.date ? reschedulingAppointment.date : new Date(),
    };
  }

  renderHeader = () => {
    const dateFormat = 'MMMM YYYY';

    return (
      <div className="header row flex-middle" style={{ padding: this.props.showShortDay ? '1em 0' : '1.5em 0' }}>
        <div className="col col-start">
          <div className="icon" onClick={this.prevMonth}>
            {'<'}
          </div>
        </div>
        <div className="col col-center">
          <span>{moment(this.state.currentMonth).format(dateFormat)}</span>
        </div>
        <div className="col col-end" onClick={this.nextMonth}>
          <div className="icon">{'>'}</div>
        </div>
      </div>
    );
  };

  renderDays = () => {
    const { showShortDay } = this.props;
    const dateFormat = 'dddd';
    const days = [];

    let startDate = moment(this.state.currentMonth).startOf('week');
    let startDateMob = moment(this.state.currentMonth).startOf('week');
    startDate.add(-1, 'days').format(dateFormat);
    startDateMob.add(-1, 'days').format('dd');
    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="col col-center" key={i}>
          <DayFull>{startDate.add(1, 'days').format(!!showShortDay ? 'dd' : dateFormat)}</DayFull>
          <DayMobile>{startDateMob.add(1, 'days').format('dd')}</DayMobile>
        </div>,
      );
    }

    return <div className="days row">{days}</div>;
  };

  renderTimeSelectionTable = (slots, selectedDay) => {
    const { onSlotSelected, reschedulingAppointment } = this.props;
    if (!slots.openAppointments) return <div />;

    const daySlots = slots.openAppointments.filter((x) => x.date === this.state.selectedDate);

    // console.log('selectedDay', selectedDay);

    if (!daySlots || daySlots.length < 1) return <div />;

    const morning = [];
    const afternoon = [];
    const evening = [];
    for (let index = 0; index < daySlots.length; index++) {
      const element = daySlots[index];
      const slt = moment(`${element.date} ${element.startTime}`, 'MM/DD/YYYY HH:mm');
      element.dt = slt;

      if (slt.isSameOrAfter(moment(`${element.date} 17:00`, 'MM/DD/YYYY HH:mm'))) {
        evening.push(element);
      } else if (slt.isSameOrAfter(moment(`${element.date} 12:00`, 'MM/DD/YYYY HH:mm'))) {
        afternoon.push(element);
      } else {
        morning.push(element);
      }
    }

    return (
      <ExpandedRow>
        <div style={{ marginBottom: '24px' }}>
          <Text fontWeight={400} fontSize={3} mb="22px" textAlign={['center', 'center']} style={{ padding: '0 30px' }}>
            {moment(this.state.selectedDate, 'MM/DD/YYYY').format('dddd, MMMM Do')}
          </Text>
          <div />
          {reschedulingAppointment &&
            this.state.selectedDate === reschedulingAppointment.date && (
              <Text fontWeight={400} fontSize={2} textAlign={['center', 'center']} mt={1} mb={3}>
                <span>Currently Booked:&nbsp;</span>
                <span style={{ fontWeight: '600' }}>{moment(reschedulingAppointment.startTime, 'HH:mm').format('hh:mm A')}</span>
              </Text>
            )}
          {daySlots &&
            daySlots.length > 0 && (
              <Flex flexDirection={'row'} justifyContent={'center'}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d={`M4.35936 7.76072C4.43553 7.76072 4.52049 7.77244 4.61424 7.79588C4.70799 7.81932 4.80174 7.85154 4.89549 7.89256C4.98924 7.93357 5.08299 7.97166 5.17674 8.00682C5.27049 8.04197 5.35545 8.07713 5.43162 8.11229L5.291 8.12986C5.24412 8.13572 5.19432 8.13865 5.14158 8.13865C5.04197 8.13865 4.95115 8.124 4.86912 8.09471C4.78709 8.06541 4.71092 8.02732 4.64061 7.98045C4.57029 7.93357 4.49998 7.89842 4.42967 7.87498C4.35936 7.85154 4.2949 7.83397 4.23631 7.82225C4.17772 7.82225 4.12498 7.83397 4.07811 7.8574C4.03123 7.88084 3.98436 7.90721 3.93748 7.9365C3.93748 7.91307 3.91697 7.90135 3.87596 7.90135C3.91697 7.86033 3.99315 7.82811 4.10447 7.80467C4.2158 7.78123 4.30076 7.76658 4.35936 7.76072ZM5.54588 8.15623C5.78611 8.15623 6.00584 8.19725 6.20506 8.27928C6.12303 8.30857 6.041 8.33201 5.95897 8.34959C5.87693 8.36717 5.79197 8.37889 5.70408 8.38475C5.5869 8.38475 5.48143 8.37303 5.38768 8.34959C5.41697 8.30272 5.44627 8.27342 5.47557 8.2617C5.50486 8.24998 5.5283 8.21482 5.54588 8.15623ZM8.99998 -1.878e-05C9.82615 -1.878e-05 10.6201 0.10838 11.3818 0.325177C12.1435 0.541973 12.8584 0.843731 13.5263 1.23045C14.1943 1.61717 14.8037 2.08885 15.3545 2.64549C15.9053 3.20213 16.374 3.80857 16.7607 4.46482C17.1474 5.12107 17.4521 5.83592 17.6748 6.60936C17.8974 7.38279 18.0058 8.17967 18 8.99998C18 9.82615 17.8916 10.6201 17.6748 11.3818C17.458 12.1435 17.1562 12.8584 16.7695 13.5263C16.3828 14.1943 15.9111 14.8037 15.3545 15.3545C14.7978 15.9053 14.1914 16.374 13.5351 16.7607C12.8789 17.1474 12.164 17.4521 11.3906 17.6748C10.6172 17.8974 9.82029 18.0058 8.99998 18C8.17381 18 7.37986 17.8916 6.61815 17.6748C5.85643 17.458 5.14158 17.1562 4.47361 16.7695C3.80565 16.3828 3.19627 15.9111 2.64549 15.3545C2.09471 14.7978 1.62596 14.1914 1.23924 13.5351C0.85252 12.8789 0.547833 12.164 0.325177 11.3906C0.10252 10.6172 -0.00587816 9.82029 -1.878e-05 8.99998C-1.878e-05 8.17381 0.10838 7.37986 0.325177 6.61815C0.541973 5.85643 0.843731 5.14158 1.23045 4.47361C1.61717 3.80565 2.08885 3.19627 2.64549 2.64549C3.20213 2.09471 3.80857 1.62596 4.46482 1.23924C5.12107 0.85252 5.83592 0.547833 6.60936 0.325177C7.38279 0.10252 8.17967 -0.00587816 8.99998 -1.878e-05ZM15.6972 4.87791C15.6152 4.749 15.5332 4.62596 15.4512 4.50877C15.3691 4.39158 15.2842 4.27147 15.1963 4.14842C15.1846 4.20115 15.1699 4.23924 15.1523 4.26268C15.1347 4.28611 15.123 4.33885 15.1172 4.42088C15.1172 4.47361 15.1377 4.52342 15.1787 4.57029C15.2197 4.61717 15.2724 4.66404 15.3369 4.71092C15.4013 4.75779 15.4658 4.79295 15.5303 4.81639C15.5947 4.83982 15.6504 4.86033 15.6972 4.87791ZM15.0908 4.01658C15.0908 4.06346 15.082 4.09568 15.0644 4.11326H15.1172C15.1406 4.11326 15.1582 4.11619 15.1699 4.12205L15.0908 4.01658ZM8.99998 16.875C9.66795 16.875 10.3213 16.79 10.9599 16.6201C11.5986 16.4502 12.2021 16.2099 12.7705 15.8994C13.3388 15.5888 13.8662 15.208 14.3525 14.7568C14.8388 14.3056 15.2637 13.8017 15.6269 13.2451C15.5508 13.0693 15.4775 12.8906 15.4072 12.709C15.3369 12.5273 15.3017 12.3398 15.3017 12.1465C15.3017 11.9355 15.3105 11.7656 15.3281 11.6367C15.3457 11.5078 15.3662 11.3935 15.3896 11.2939C15.4131 11.1943 15.4248 11.1094 15.4248 11.039C15.4248 10.9687 15.416 10.8779 15.3984 10.7666C15.3808 10.6553 15.331 10.5351 15.249 10.4062C15.167 10.2773 15.0586 10.0957 14.9238 9.86131C14.9297 9.82029 14.9385 9.76463 14.9502 9.69432C14.9619 9.624 14.9736 9.55076 14.9853 9.47459C14.9971 9.39842 15 9.32811 14.9941 9.26365C14.9883 9.1992 14.9736 9.14354 14.9502 9.09666C14.7978 9.07908 14.6396 9.04686 14.4756 8.99998C14.3115 8.95311 14.165 8.88279 14.0361 8.78904L14.0888 8.7451C14.0127 8.76268 13.9365 8.78611 13.8603 8.81541C13.7842 8.84471 13.7109 8.87693 13.6406 8.91209C13.5703 8.94725 13.4941 8.97068 13.4121 8.9824C13.3301 8.99412 13.251 9.00584 13.1748 9.01756L13.0342 8.99998L13.0605 8.93846C12.9785 8.9619 12.8906 8.99119 12.7969 9.02635C12.7031 9.0615 12.6123 9.07908 12.5244 9.07908C12.4658 9.07908 12.3808 9.05857 12.2695 9.01756C12.1582 8.97654 12.0469 8.92674 11.9355 8.86815C11.8242 8.80955 11.7246 8.7451 11.6367 8.67479C11.5488 8.60447 11.5049 8.53709 11.5049 8.47264L11.5224 8.44627C11.4931 8.41111 11.4551 8.37889 11.4082 8.34959C11.3613 8.32029 11.3174 8.291 11.2763 8.2617C11.2353 8.2324 11.1972 8.20018 11.1621 8.16502C11.1269 8.12986 11.1123 8.08885 11.1181 8.04197L11.2148 7.96287L11.0127 7.9365L10.9424 7.67283C10.9541 7.70213 10.9804 7.71385 11.0215 7.70799C11.0625 7.70213 11.0947 7.69041 11.1181 7.67283L10.8017 7.50584L11.0215 6.94334C10.9394 6.63865 10.9189 6.40428 10.9599 6.24022C11.001 6.07615 11.0801 5.94139 11.1972 5.83592C11.3144 5.73045 11.4433 5.62498 11.584 5.51951C11.7246 5.41404 11.8681 5.27049 12.0146 5.08885L11.9883 4.98338L12.5683 4.28025L12.7002 4.26268C12.8642 4.26268 13.0488 4.25682 13.2539 4.2451C13.459 4.23338 13.667 4.21287 13.8779 4.18357C14.0888 4.15428 14.2969 4.12498 14.5019 4.09568C14.707 4.06639 14.8945 4.0283 15.0644 3.98143C14.8769 3.75877 14.6806 3.54783 14.4756 3.34861C14.2705 3.1494 14.0508 2.95897 13.8164 2.77732C13.7519 2.80076 13.6728 2.83299 13.5791 2.874C13.4853 2.91502 13.3916 2.96775 13.2978 3.03221C13.2041 3.09666 13.1308 3.16697 13.0781 3.24315C13.0254 3.31932 12.9931 3.39842 12.9814 3.48045L13.0342 3.64744C12.9287 3.81736 12.8115 3.92283 12.6826 3.96385C12.5537 4.00486 12.4219 4.0283 12.2871 4.03416C12.1523 4.04002 12.0117 4.04002 11.8652 4.03416C11.7187 4.0283 11.5781 4.05467 11.4433 4.11326L11.3027 3.81443L11.4346 3.30467L11.2851 3.08494L12.8056 2.61033C12.7412 2.44627 12.6357 2.32322 12.4892 2.24119C12.3428 2.15916 12.1816 2.11815 12.0058 2.11815V2.03025L12.498 1.95115C11.9531 1.68162 11.3877 1.47654 10.8017 1.33592C10.2158 1.19529 9.61522 1.12498 8.99998 1.12498C8.49022 1.12498 7.98631 1.17479 7.48826 1.2744C6.99022 1.374 6.50975 1.51756 6.04686 1.70506C5.58397 1.89256 5.13572 2.12693 4.70213 2.40818C4.26854 2.68943 3.87303 3.00584 3.51561 3.3574C3.66795 3.3574 3.78514 3.39549 3.86717 3.47166C3.9492 3.54783 4.02537 3.63279 4.09568 3.72654C4.166 3.82029 4.23924 3.90525 4.31541 3.98143C4.39158 4.0576 4.49412 4.09861 4.62303 4.10447L4.76365 3.999L4.74607 3.80565L5.03611 3.39256L4.8076 2.74217C4.8369 2.72459 4.88084 2.69529 4.93943 2.65428C4.99803 2.61326 5.04783 2.59275 5.08885 2.59275C5.26463 2.59275 5.3994 2.60154 5.49315 2.61912C5.5869 2.6367 5.66893 2.66893 5.73924 2.7158C5.80955 2.76268 5.87107 2.83006 5.92381 2.91795C5.97654 3.00584 6.05857 3.11717 6.1699 3.25193L6.48631 3.00584C6.5449 3.02928 6.63865 3.06736 6.76756 3.1201C6.89647 3.17283 7.0283 3.23729 7.16307 3.31346C7.29783 3.38963 7.41209 3.46873 7.50584 3.55076C7.59959 3.63279 7.6494 3.70897 7.65525 3.77928C7.65525 3.86717 7.62303 3.93748 7.55857 3.99022C7.49412 4.04295 7.40916 4.0869 7.30369 4.12205C7.19822 4.15721 7.08982 4.18357 6.9785 4.20115C6.86717 4.21873 6.75584 4.24217 6.64451 4.27147C6.53318 4.30076 6.44822 4.33006 6.38963 4.35936C6.33104 4.38865 6.29588 4.43846 6.28416 4.50877L6.79393 4.67576C6.67674 4.77537 6.55076 4.86619 6.416 4.94822C6.28123 5.03025 6.14061 5.10643 5.99412 5.17674L6.02928 5.32615L5.22068 5.64256V5.88865L5.15916 5.91502L5.20311 5.6074L5.16795 5.59861C5.12693 5.59861 5.1035 5.6074 5.09764 5.62498C5.09178 5.64256 5.08885 5.66307 5.08885 5.6865C5.08885 5.70994 5.09471 5.73338 5.10643 5.75682C5.11815 5.78025 5.12107 5.79783 5.11522 5.80955L5.00096 5.74803L5.01854 5.78318C5.01854 5.80076 5.02732 5.82713 5.0449 5.86229C5.06248 5.89744 5.08592 5.92967 5.11522 5.95897C5.14451 5.98826 5.16795 6.01756 5.18553 6.04686C5.20311 6.07615 5.21482 6.0908 5.22068 6.0908C5.22068 6.10838 5.20897 6.12596 5.18553 6.14354C5.16209 6.16111 5.13279 6.17283 5.09764 6.17869C5.06248 6.18455 5.03904 6.19334 5.02732 6.20506C5.01561 6.21678 5.01561 6.21971 5.02732 6.21385C5.10936 6.21385 5.12693 6.21971 5.08006 6.23143C5.03318 6.24315 4.95994 6.27244 4.86033 6.31932C4.76072 6.36619 4.6699 6.43357 4.58787 6.52147C4.50584 6.60936 4.45897 6.73826 4.44725 6.90818C4.44725 7.00779 4.45018 7.10447 4.45604 7.19822C4.4619 7.29197 4.45897 7.38865 4.44725 7.48826C4.36522 7.26561 4.24217 7.09568 4.07811 6.9785C3.91404 6.86131 3.71482 6.80272 3.48045 6.80272L3.10252 6.83787L3.28709 6.96092C3.18748 6.9492 3.08494 6.93748 2.97947 6.92576C2.874 6.91404 2.76561 6.91111 2.65428 6.91697C2.54295 6.92283 2.44334 6.94627 2.35545 6.98729C2.26756 7.0283 2.17967 7.08982 2.09178 7.17186L2.03904 7.56736C2.03904 7.75486 2.08006 7.90721 2.16209 8.0244C2.24412 8.14158 2.38768 8.20311 2.59275 8.20897C2.76854 8.20897 2.94139 8.1826 3.11131 8.12986C3.28123 8.07713 3.44822 8.01561 3.61229 7.94529C3.55955 8.0742 3.50096 8.19725 3.4365 8.31443C3.37205 8.43162 3.32518 8.56053 3.29588 8.70115L3.41014 8.75389C3.55076 8.66014 3.67967 8.64549 3.79686 8.70994C3.91404 8.7744 4.0283 8.86815 4.13963 8.99119C4.25096 9.11424 4.36522 9.24022 4.4824 9.36912C4.59959 9.49803 4.72557 9.59178 4.86033 9.65037L4.5615 9.80857L3.85838 9.41307C3.86424 9.42479 3.8701 9.45115 3.87596 9.49217C3.88182 9.53318 3.87889 9.54197 3.86717 9.51854L3.55076 8.9824C3.36326 8.97654 3.16404 8.94725 2.95311 8.89451C2.74217 8.84178 2.5283 8.77147 2.3115 8.68357C2.09471 8.59568 1.89256 8.499 1.70506 8.39354C1.51756 8.28807 1.34471 8.17674 1.1865 8.05955L1.12498 8.99998C1.12498 9.71482 1.22166 10.4121 1.41502 11.0918C1.60838 11.7715 1.88084 12.4101 2.2324 13.0078C2.58397 13.6054 3.01463 14.1504 3.5244 14.6426C4.03416 15.1347 4.59959 15.5537 5.22068 15.8994C5.19139 15.7763 5.18846 15.6533 5.2119 15.5303C5.23533 15.4072 5.26463 15.2842 5.29979 15.1611C5.33494 15.0381 5.37303 14.915 5.41404 14.792C5.45506 14.6689 5.47557 14.5429 5.47557 14.414C5.47557 14.2265 5.44627 14.0303 5.38768 13.8252C5.32908 13.6201 5.25877 13.4121 5.17674 13.2012C5.09471 12.9902 5.00389 12.7822 4.90428 12.5771C4.80467 12.3721 4.72557 12.1787 4.66697 11.9971C4.60838 11.8154 4.5615 11.6455 4.52635 11.4873C4.49119 11.3291 4.50877 11.1914 4.57908 11.0742L4.44725 11.0127C4.4824 10.9306 4.52928 10.8515 4.58787 10.7754C4.64647 10.6992 4.70799 10.623 4.77244 10.5469C4.8369 10.4707 4.8867 10.3887 4.92186 10.3008C4.95701 10.2129 4.97752 10.125 4.98338 10.0371C4.98338 9.9785 4.97166 9.91697 4.94822 9.85252C4.92479 9.78807 4.90428 9.72654 4.8867 9.66795L5.07127 9.7119C5.17088 9.48338 5.30565 9.32811 5.47557 9.24607C5.64549 9.16404 5.85936 9.1201 6.11717 9.11424C6.14647 9.11424 6.20799 9.12596 6.30174 9.1494C6.39549 9.17283 6.4951 9.20506 6.60057 9.24607C6.70604 9.28709 6.80565 9.31932 6.8994 9.34275C6.99315 9.36619 7.06346 9.38963 7.11033 9.41307C7.11033 9.45408 7.13377 9.48045 7.18065 9.49217C7.22752 9.50389 7.25389 9.5244 7.25975 9.55369L7.24217 9.624C7.25975 9.62986 7.30076 9.65037 7.36522 9.68553C7.42967 9.72068 7.49998 9.76463 7.57615 9.81736C7.65232 9.8701 7.71971 9.91697 7.7783 9.95799C7.8369 9.999 7.87791 10.0312 7.90135 10.0547C8.00682 10.0547 8.15037 10.0898 8.33201 10.1601C8.51365 10.2304 8.71287 10.3183 8.92967 10.4238C9.14647 10.5293 9.36033 10.6553 9.57127 10.8017C9.78221 10.9482 9.98143 11.0947 10.1689 11.2412C10.3564 11.3877 10.5 11.5342 10.5996 11.6806C10.6992 11.8271 10.7578 11.956 10.7754 12.0674L10.4765 12.3838C10.5 12.6826 10.4795 12.9111 10.415 13.0693C10.3506 13.2275 10.251 13.3594 10.1162 13.4648C9.98143 13.5703 9.82615 13.6582 9.65037 13.7285C9.47459 13.7988 9.28416 13.8984 9.07908 14.0273C9.07908 14.1445 9.04979 14.2705 8.99119 14.4053C8.9326 14.54 8.85936 14.6689 8.77147 14.792C8.68357 14.915 8.57811 15.0176 8.45506 15.0996C8.33201 15.1816 8.20897 15.2226 8.08592 15.2226L7.71678 14.9414C7.7285 14.9531 7.7285 14.9736 7.71678 15.0029C7.70506 15.0322 7.69041 15.0381 7.67283 15.0205C7.73143 15.1318 7.74607 15.2607 7.71678 15.4072C7.68748 15.5537 7.63768 15.7031 7.56736 15.8554C7.49705 16.0078 7.41795 16.1513 7.33006 16.2861C7.24217 16.4209 7.16307 16.5351 7.09275 16.6289C7.40916 16.7109 7.72557 16.7724 8.04197 16.8135C8.35838 16.8545 8.67772 16.875 8.99998 16.875Z`}
                    fill="#354E79"
                  />
                </svg>
                <Text ml={3} fontSize={'14px'}>{`${daySlots[0].timezoneLongName} - US (${momentTimezone(selectedDay)
                  .tz(daySlots[0].timezoneName)
                  .format('z')})`}</Text>
              </Flex>
            )}
          {morning &&
            morning.length > 0 && (
              <Text fontWeight={400} fontSize={3} textAlign={['center', 'center']} color="#949494" mt={3} mb={2}>
                Morning
              </Text>
            )}
          {morning &&
            morning.length > 0 && (
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-around',
                }}
              >
                {morning.map((sl) => (
                  <SlotButton
                    key={`slot${sl.id}`}
                    variant="outline"
                    onClick={() => {
                      onSlotSelected(sl);
                    }}
                  >
                    {moment(sl.dt).format('hh:mm A')}
                  </SlotButton>
                ))}
              </div>
            )}
          {afternoon &&
            afternoon.length > 0 && (
              <Text fontWeight={400} fontSize={3} textAlign={['center', 'center']} color="#949494" mt={3} mb={2}>
                Afternoon
              </Text>
            )}
          {afternoon &&
            afternoon.length > 0 && (
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-around',
                }}
              >
                {afternoon.map((sl) => (
                  <SlotButton
                    variant="outline"
                    onClick={() => {
                      onSlotSelected(sl);
                    }}
                    key={`slot${sl.id}`}
                  >
                    {moment(sl.dt).format('hh:mm A')}
                  </SlotButton>
                ))}
              </div>
            )}
          {evening &&
            evening.length > 0 && (
              <Text fontWeight={400} fontSize={3} textAlign={['center', 'center']} color="#949494" mt={3} mb={2}>
                Evening
              </Text>
            )}
          {evening &&
            evening.length > 0 && (
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-around',
                }}
              >
                {evening.map((sl) => (
                  <SlotButton
                    variant="outline"
                    onClick={() => {
                      onSlotSelected(sl);
                    }}
                    key={`slot${sl.id}`}
                  >
                    {moment(sl.dt).format('hh:mm A')}
                  </SlotButton>
                ))}
              </div>
            )}
          {daySlots &&
            daySlots.length > 0 && (
              <Flex flexDirection={'row'} mt={3}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d={`M4.35936 7.76072C4.43553 7.76072 4.52049 7.77244 4.61424 7.79588C4.70799 7.81932 4.80174 7.85154 4.89549 7.89256C4.98924 7.93357 5.08299 7.97166 5.17674 8.00682C5.27049 8.04197 5.35545 8.07713 5.43162 8.11229L5.291 8.12986C5.24412 8.13572 5.19432 8.13865 5.14158 8.13865C5.04197 8.13865 4.95115 8.124 4.86912 8.09471C4.78709 8.06541 4.71092 8.02732 4.64061 7.98045C4.57029 7.93357 4.49998 7.89842 4.42967 7.87498C4.35936 7.85154 4.2949 7.83397 4.23631 7.82225C4.17772 7.82225 4.12498 7.83397 4.07811 7.8574C4.03123 7.88084 3.98436 7.90721 3.93748 7.9365C3.93748 7.91307 3.91697 7.90135 3.87596 7.90135C3.91697 7.86033 3.99315 7.82811 4.10447 7.80467C4.2158 7.78123 4.30076 7.76658 4.35936 7.76072ZM5.54588 8.15623C5.78611 8.15623 6.00584 8.19725 6.20506 8.27928C6.12303 8.30857 6.041 8.33201 5.95897 8.34959C5.87693 8.36717 5.79197 8.37889 5.70408 8.38475C5.5869 8.38475 5.48143 8.37303 5.38768 8.34959C5.41697 8.30272 5.44627 8.27342 5.47557 8.2617C5.50486 8.24998 5.5283 8.21482 5.54588 8.15623ZM8.99998 -1.878e-05C9.82615 -1.878e-05 10.6201 0.10838 11.3818 0.325177C12.1435 0.541973 12.8584 0.843731 13.5263 1.23045C14.1943 1.61717 14.8037 2.08885 15.3545 2.64549C15.9053 3.20213 16.374 3.80857 16.7607 4.46482C17.1474 5.12107 17.4521 5.83592 17.6748 6.60936C17.8974 7.38279 18.0058 8.17967 18 8.99998C18 9.82615 17.8916 10.6201 17.6748 11.3818C17.458 12.1435 17.1562 12.8584 16.7695 13.5263C16.3828 14.1943 15.9111 14.8037 15.3545 15.3545C14.7978 15.9053 14.1914 16.374 13.5351 16.7607C12.8789 17.1474 12.164 17.4521 11.3906 17.6748C10.6172 17.8974 9.82029 18.0058 8.99998 18C8.17381 18 7.37986 17.8916 6.61815 17.6748C5.85643 17.458 5.14158 17.1562 4.47361 16.7695C3.80565 16.3828 3.19627 15.9111 2.64549 15.3545C2.09471 14.7978 1.62596 14.1914 1.23924 13.5351C0.85252 12.8789 0.547833 12.164 0.325177 11.3906C0.10252 10.6172 -0.00587816 9.82029 -1.878e-05 8.99998C-1.878e-05 8.17381 0.10838 7.37986 0.325177 6.61815C0.541973 5.85643 0.843731 5.14158 1.23045 4.47361C1.61717 3.80565 2.08885 3.19627 2.64549 2.64549C3.20213 2.09471 3.80857 1.62596 4.46482 1.23924C5.12107 0.85252 5.83592 0.547833 6.60936 0.325177C7.38279 0.10252 8.17967 -0.00587816 8.99998 -1.878e-05ZM15.6972 4.87791C15.6152 4.749 15.5332 4.62596 15.4512 4.50877C15.3691 4.39158 15.2842 4.27147 15.1963 4.14842C15.1846 4.20115 15.1699 4.23924 15.1523 4.26268C15.1347 4.28611 15.123 4.33885 15.1172 4.42088C15.1172 4.47361 15.1377 4.52342 15.1787 4.57029C15.2197 4.61717 15.2724 4.66404 15.3369 4.71092C15.4013 4.75779 15.4658 4.79295 15.5303 4.81639C15.5947 4.83982 15.6504 4.86033 15.6972 4.87791ZM15.0908 4.01658C15.0908 4.06346 15.082 4.09568 15.0644 4.11326H15.1172C15.1406 4.11326 15.1582 4.11619 15.1699 4.12205L15.0908 4.01658ZM8.99998 16.875C9.66795 16.875 10.3213 16.79 10.9599 16.6201C11.5986 16.4502 12.2021 16.2099 12.7705 15.8994C13.3388 15.5888 13.8662 15.208 14.3525 14.7568C14.8388 14.3056 15.2637 13.8017 15.6269 13.2451C15.5508 13.0693 15.4775 12.8906 15.4072 12.709C15.3369 12.5273 15.3017 12.3398 15.3017 12.1465C15.3017 11.9355 15.3105 11.7656 15.3281 11.6367C15.3457 11.5078 15.3662 11.3935 15.3896 11.2939C15.4131 11.1943 15.4248 11.1094 15.4248 11.039C15.4248 10.9687 15.416 10.8779 15.3984 10.7666C15.3808 10.6553 15.331 10.5351 15.249 10.4062C15.167 10.2773 15.0586 10.0957 14.9238 9.86131C14.9297 9.82029 14.9385 9.76463 14.9502 9.69432C14.9619 9.624 14.9736 9.55076 14.9853 9.47459C14.9971 9.39842 15 9.32811 14.9941 9.26365C14.9883 9.1992 14.9736 9.14354 14.9502 9.09666C14.7978 9.07908 14.6396 9.04686 14.4756 8.99998C14.3115 8.95311 14.165 8.88279 14.0361 8.78904L14.0888 8.7451C14.0127 8.76268 13.9365 8.78611 13.8603 8.81541C13.7842 8.84471 13.7109 8.87693 13.6406 8.91209C13.5703 8.94725 13.4941 8.97068 13.4121 8.9824C13.3301 8.99412 13.251 9.00584 13.1748 9.01756L13.0342 8.99998L13.0605 8.93846C12.9785 8.9619 12.8906 8.99119 12.7969 9.02635C12.7031 9.0615 12.6123 9.07908 12.5244 9.07908C12.4658 9.07908 12.3808 9.05857 12.2695 9.01756C12.1582 8.97654 12.0469 8.92674 11.9355 8.86815C11.8242 8.80955 11.7246 8.7451 11.6367 8.67479C11.5488 8.60447 11.5049 8.53709 11.5049 8.47264L11.5224 8.44627C11.4931 8.41111 11.4551 8.37889 11.4082 8.34959C11.3613 8.32029 11.3174 8.291 11.2763 8.2617C11.2353 8.2324 11.1972 8.20018 11.1621 8.16502C11.1269 8.12986 11.1123 8.08885 11.1181 8.04197L11.2148 7.96287L11.0127 7.9365L10.9424 7.67283C10.9541 7.70213 10.9804 7.71385 11.0215 7.70799C11.0625 7.70213 11.0947 7.69041 11.1181 7.67283L10.8017 7.50584L11.0215 6.94334C10.9394 6.63865 10.9189 6.40428 10.9599 6.24022C11.001 6.07615 11.0801 5.94139 11.1972 5.83592C11.3144 5.73045 11.4433 5.62498 11.584 5.51951C11.7246 5.41404 11.8681 5.27049 12.0146 5.08885L11.9883 4.98338L12.5683 4.28025L12.7002 4.26268C12.8642 4.26268 13.0488 4.25682 13.2539 4.2451C13.459 4.23338 13.667 4.21287 13.8779 4.18357C14.0888 4.15428 14.2969 4.12498 14.5019 4.09568C14.707 4.06639 14.8945 4.0283 15.0644 3.98143C14.8769 3.75877 14.6806 3.54783 14.4756 3.34861C14.2705 3.1494 14.0508 2.95897 13.8164 2.77732C13.7519 2.80076 13.6728 2.83299 13.5791 2.874C13.4853 2.91502 13.3916 2.96775 13.2978 3.03221C13.2041 3.09666 13.1308 3.16697 13.0781 3.24315C13.0254 3.31932 12.9931 3.39842 12.9814 3.48045L13.0342 3.64744C12.9287 3.81736 12.8115 3.92283 12.6826 3.96385C12.5537 4.00486 12.4219 4.0283 12.2871 4.03416C12.1523 4.04002 12.0117 4.04002 11.8652 4.03416C11.7187 4.0283 11.5781 4.05467 11.4433 4.11326L11.3027 3.81443L11.4346 3.30467L11.2851 3.08494L12.8056 2.61033C12.7412 2.44627 12.6357 2.32322 12.4892 2.24119C12.3428 2.15916 12.1816 2.11815 12.0058 2.11815V2.03025L12.498 1.95115C11.9531 1.68162 11.3877 1.47654 10.8017 1.33592C10.2158 1.19529 9.61522 1.12498 8.99998 1.12498C8.49022 1.12498 7.98631 1.17479 7.48826 1.2744C6.99022 1.374 6.50975 1.51756 6.04686 1.70506C5.58397 1.89256 5.13572 2.12693 4.70213 2.40818C4.26854 2.68943 3.87303 3.00584 3.51561 3.3574C3.66795 3.3574 3.78514 3.39549 3.86717 3.47166C3.9492 3.54783 4.02537 3.63279 4.09568 3.72654C4.166 3.82029 4.23924 3.90525 4.31541 3.98143C4.39158 4.0576 4.49412 4.09861 4.62303 4.10447L4.76365 3.999L4.74607 3.80565L5.03611 3.39256L4.8076 2.74217C4.8369 2.72459 4.88084 2.69529 4.93943 2.65428C4.99803 2.61326 5.04783 2.59275 5.08885 2.59275C5.26463 2.59275 5.3994 2.60154 5.49315 2.61912C5.5869 2.6367 5.66893 2.66893 5.73924 2.7158C5.80955 2.76268 5.87107 2.83006 5.92381 2.91795C5.97654 3.00584 6.05857 3.11717 6.1699 3.25193L6.48631 3.00584C6.5449 3.02928 6.63865 3.06736 6.76756 3.1201C6.89647 3.17283 7.0283 3.23729 7.16307 3.31346C7.29783 3.38963 7.41209 3.46873 7.50584 3.55076C7.59959 3.63279 7.6494 3.70897 7.65525 3.77928C7.65525 3.86717 7.62303 3.93748 7.55857 3.99022C7.49412 4.04295 7.40916 4.0869 7.30369 4.12205C7.19822 4.15721 7.08982 4.18357 6.9785 4.20115C6.86717 4.21873 6.75584 4.24217 6.64451 4.27147C6.53318 4.30076 6.44822 4.33006 6.38963 4.35936C6.33104 4.38865 6.29588 4.43846 6.28416 4.50877L6.79393 4.67576C6.67674 4.77537 6.55076 4.86619 6.416 4.94822C6.28123 5.03025 6.14061 5.10643 5.99412 5.17674L6.02928 5.32615L5.22068 5.64256V5.88865L5.15916 5.91502L5.20311 5.6074L5.16795 5.59861C5.12693 5.59861 5.1035 5.6074 5.09764 5.62498C5.09178 5.64256 5.08885 5.66307 5.08885 5.6865C5.08885 5.70994 5.09471 5.73338 5.10643 5.75682C5.11815 5.78025 5.12107 5.79783 5.11522 5.80955L5.00096 5.74803L5.01854 5.78318C5.01854 5.80076 5.02732 5.82713 5.0449 5.86229C5.06248 5.89744 5.08592 5.92967 5.11522 5.95897C5.14451 5.98826 5.16795 6.01756 5.18553 6.04686C5.20311 6.07615 5.21482 6.0908 5.22068 6.0908C5.22068 6.10838 5.20897 6.12596 5.18553 6.14354C5.16209 6.16111 5.13279 6.17283 5.09764 6.17869C5.06248 6.18455 5.03904 6.19334 5.02732 6.20506C5.01561 6.21678 5.01561 6.21971 5.02732 6.21385C5.10936 6.21385 5.12693 6.21971 5.08006 6.23143C5.03318 6.24315 4.95994 6.27244 4.86033 6.31932C4.76072 6.36619 4.6699 6.43357 4.58787 6.52147C4.50584 6.60936 4.45897 6.73826 4.44725 6.90818C4.44725 7.00779 4.45018 7.10447 4.45604 7.19822C4.4619 7.29197 4.45897 7.38865 4.44725 7.48826C4.36522 7.26561 4.24217 7.09568 4.07811 6.9785C3.91404 6.86131 3.71482 6.80272 3.48045 6.80272L3.10252 6.83787L3.28709 6.96092C3.18748 6.9492 3.08494 6.93748 2.97947 6.92576C2.874 6.91404 2.76561 6.91111 2.65428 6.91697C2.54295 6.92283 2.44334 6.94627 2.35545 6.98729C2.26756 7.0283 2.17967 7.08982 2.09178 7.17186L2.03904 7.56736C2.03904 7.75486 2.08006 7.90721 2.16209 8.0244C2.24412 8.14158 2.38768 8.20311 2.59275 8.20897C2.76854 8.20897 2.94139 8.1826 3.11131 8.12986C3.28123 8.07713 3.44822 8.01561 3.61229 7.94529C3.55955 8.0742 3.50096 8.19725 3.4365 8.31443C3.37205 8.43162 3.32518 8.56053 3.29588 8.70115L3.41014 8.75389C3.55076 8.66014 3.67967 8.64549 3.79686 8.70994C3.91404 8.7744 4.0283 8.86815 4.13963 8.99119C4.25096 9.11424 4.36522 9.24022 4.4824 9.36912C4.59959 9.49803 4.72557 9.59178 4.86033 9.65037L4.5615 9.80857L3.85838 9.41307C3.86424 9.42479 3.8701 9.45115 3.87596 9.49217C3.88182 9.53318 3.87889 9.54197 3.86717 9.51854L3.55076 8.9824C3.36326 8.97654 3.16404 8.94725 2.95311 8.89451C2.74217 8.84178 2.5283 8.77147 2.3115 8.68357C2.09471 8.59568 1.89256 8.499 1.70506 8.39354C1.51756 8.28807 1.34471 8.17674 1.1865 8.05955L1.12498 8.99998C1.12498 9.71482 1.22166 10.4121 1.41502 11.0918C1.60838 11.7715 1.88084 12.4101 2.2324 13.0078C2.58397 13.6054 3.01463 14.1504 3.5244 14.6426C4.03416 15.1347 4.59959 15.5537 5.22068 15.8994C5.19139 15.7763 5.18846 15.6533 5.2119 15.5303C5.23533 15.4072 5.26463 15.2842 5.29979 15.1611C5.33494 15.0381 5.37303 14.915 5.41404 14.792C5.45506 14.6689 5.47557 14.5429 5.47557 14.414C5.47557 14.2265 5.44627 14.0303 5.38768 13.8252C5.32908 13.6201 5.25877 13.4121 5.17674 13.2012C5.09471 12.9902 5.00389 12.7822 4.90428 12.5771C4.80467 12.3721 4.72557 12.1787 4.66697 11.9971C4.60838 11.8154 4.5615 11.6455 4.52635 11.4873C4.49119 11.3291 4.50877 11.1914 4.57908 11.0742L4.44725 11.0127C4.4824 10.9306 4.52928 10.8515 4.58787 10.7754C4.64647 10.6992 4.70799 10.623 4.77244 10.5469C4.8369 10.4707 4.8867 10.3887 4.92186 10.3008C4.95701 10.2129 4.97752 10.125 4.98338 10.0371C4.98338 9.9785 4.97166 9.91697 4.94822 9.85252C4.92479 9.78807 4.90428 9.72654 4.8867 9.66795L5.07127 9.7119C5.17088 9.48338 5.30565 9.32811 5.47557 9.24607C5.64549 9.16404 5.85936 9.1201 6.11717 9.11424C6.14647 9.11424 6.20799 9.12596 6.30174 9.1494C6.39549 9.17283 6.4951 9.20506 6.60057 9.24607C6.70604 9.28709 6.80565 9.31932 6.8994 9.34275C6.99315 9.36619 7.06346 9.38963 7.11033 9.41307C7.11033 9.45408 7.13377 9.48045 7.18065 9.49217C7.22752 9.50389 7.25389 9.5244 7.25975 9.55369L7.24217 9.624C7.25975 9.62986 7.30076 9.65037 7.36522 9.68553C7.42967 9.72068 7.49998 9.76463 7.57615 9.81736C7.65232 9.8701 7.71971 9.91697 7.7783 9.95799C7.8369 9.999 7.87791 10.0312 7.90135 10.0547C8.00682 10.0547 8.15037 10.0898 8.33201 10.1601C8.51365 10.2304 8.71287 10.3183 8.92967 10.4238C9.14647 10.5293 9.36033 10.6553 9.57127 10.8017C9.78221 10.9482 9.98143 11.0947 10.1689 11.2412C10.3564 11.3877 10.5 11.5342 10.5996 11.6806C10.6992 11.8271 10.7578 11.956 10.7754 12.0674L10.4765 12.3838C10.5 12.6826 10.4795 12.9111 10.415 13.0693C10.3506 13.2275 10.251 13.3594 10.1162 13.4648C9.98143 13.5703 9.82615 13.6582 9.65037 13.7285C9.47459 13.7988 9.28416 13.8984 9.07908 14.0273C9.07908 14.1445 9.04979 14.2705 8.99119 14.4053C8.9326 14.54 8.85936 14.6689 8.77147 14.792C8.68357 14.915 8.57811 15.0176 8.45506 15.0996C8.33201 15.1816 8.20897 15.2226 8.08592 15.2226L7.71678 14.9414C7.7285 14.9531 7.7285 14.9736 7.71678 15.0029C7.70506 15.0322 7.69041 15.0381 7.67283 15.0205C7.73143 15.1318 7.74607 15.2607 7.71678 15.4072C7.68748 15.5537 7.63768 15.7031 7.56736 15.8554C7.49705 16.0078 7.41795 16.1513 7.33006 16.2861C7.24217 16.4209 7.16307 16.5351 7.09275 16.6289C7.40916 16.7109 7.72557 16.7724 8.04197 16.8135C8.35838 16.8545 8.67772 16.875 8.99998 16.875Z`}
                    fill="#354E79"
                  />
                </svg>
                <Text ml={3} fontSize={'14px'}>{`${daySlots[0].timezoneLongName} - US (${momentTimezone(selectedDay)
                  .tz(daySlots[0].timezoneName)
                  .format('z')})`}</Text>
              </Flex>
            )}
        </div>
        <div
          style={{ position: 'absolute', top: '10px', right: '10px' }}
          onClick={(e) => {
            this.setState({ selectedDate: null });
          }}
        >
          <img src="https://uploads-ssl.webflow.com/5c17fa35c934d0037d5c6288/5c17fa35c934d04b505c628f_Screen%20Shot%202018-09-12%20at%2012.14.25%20PM.png" alt="" width="30px" />
        </div>
      </ExpandedRow>
    );
  };

  renderCells = (slots, loading, error, expandDay, hideNoSlot) => {
    const { currentMonth, selectedDate } = this.state;
    const monthStart = moment(currentMonth).startOf('month');
    const monthEnd = moment(currentMonth).endOf('month');
    const startDate = moment(monthStart).startOf('week');
    const endDate = moment(monthEnd).endOf('week');

    const dateFormat = 'D';
    const rows = [];

    let days = [];
    let day = startDate;
    let formattedDate = '';

    const counts =
      slots && slots.openAppointments
        ? slots.openAppointments.reduce((p, c) => {
            const name = c.date;
            if (!p.hasOwnProperty(name)) {
              p[name] = 0;
            }
            p[name]++;
            return p;
          }, {})
        : [];

    while (day <= endDate) {
      let isExpandDayInRow = false;
      for (let i = 0; i < 7; i++) {
        formattedDate = moment(day).format(dateFormat);
        if (!isExpandDayInRow) {
          isExpandDayInRow =
            expandDay ===
            moment(day)
              .format('MM/DD/YYYY')
              .toString();
        }
        const clone = moment(day)
          .format('MM/DD/YYYY')
          .toString();
        const count =
          counts[
            moment(day)
              .format('MM/DD/YYYY')
              .toString()
          ];

        days.push(
          <div
            className={`col cell ${
              !moment(day).isSame(moment(monthStart), 'month') || moment(day).isBefore(moment(), 'day') ? 'disabled' : moment(day).isSame(moment(selectedDate), 'day') ? 'selected' : ''
            }`}
            style={{
              height: this.props.showShortDay ? '3em' : '',
            }}
            key={day}
            onClick={(e) => {
              if (!count || count < 1) return;
              e.target.scrollIntoView({ behavior: 'smooth' });
              this.onDateClick(clone);
            }}
          >
            <span className="number">{formattedDate}</span>
            <span className="bg">{formattedDate}</span>
            {count && count > 0 ? (
              <TimesWrapper>
                {!!this.props.showShortDay ? (
                  <TimesIndicatorWeb />
                ) : (
                  <TimesText>
                    {`${count} slot${count > 1 ? 's' : ''}`}
                    <div>
                      <img src="https://uploads-ssl.webflow.com/5c17fa35c934d0037d5c6288/5c17fa35c934d07aa25c6298_arrow%20down.png" alt="" width="20px" />
                    </div>
                  </TimesText>
                )}
                <TimesIndicator />
              </TimesWrapper>
            ) : (
              ''
            )}
          </div>,
        );
        day = moment(day).add(1, 'days');
      }
      rows.push(
        <div className="row" key={day}>
          {days}
        </div>,
      );

      if (isExpandDayInRow) {
        rows.push(this.renderTimeSelectionTable(slots, expandDay));
      }
      days = [];
    }

    return (
      <div className="body" style={{ position: 'relative' }}>
        {rows}
        {!loading && !hideNoSlot &&
          (!slots || !slots.openAppointments || slots.openAppointments.length <1) && (
            <Flex justifyContent={'center'} alignItems={'center'} style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, background: 'rgba(255,255,255,0.75' }}>
              <Card style={{ maxWidth: 'fit-content', padding: '8px 12px' }}>
                <Text style={{ fontSize: '13px' }} fontWeight={300} textAlign={'center'}>
                  No opening
                  <br />
                  available in
                  <br />
                  <span style={{ fontWeight: 500 }}>{moment(currentMonth).format('MMMM')}</span>
                </Text>
              </Card>
            </Flex>
          )}
        {loading ? (
          <AvailabilitiesLoadingErrorWrapper>
            <SpinLoader />
            <AvailabilitiesLoadingErrorText>Loading Availabilities</AvailabilitiesLoadingErrorText>
          </AvailabilitiesLoadingErrorWrapper>
        ) : null}
        {error ? (
          <AvailabilitiesLoadingErrorWrapper>
            <AvailabilitiesLoadingErrorText className="error title">An error occured</AvailabilitiesLoadingErrorText>
            <AvailabilitiesLoadingErrorText className="error">Unable to retrieve availabilities</AvailabilitiesLoadingErrorText>
          </AvailabilitiesLoadingErrorWrapper>
        ) : null}
      </div>
    );
  };

  onDateClick = (day) => {
    this.setState({
      selectedDate: day !== this.state.selectedDate ? day : null,
    });
  };

  nextMonth = () => {
    this.setState({
      currentMonth: moment(this.state.currentMonth).add(1, 'months'),
    });
  };

  prevMonth = () => {
    this.setState({
      currentMonth: moment(this.state.currentMonth).add(-1, 'months'),
    });
  };

  componentDidUpdate(prevProps) {
    // console.log('CDU');
    const { reschedulingAppointment, nextAppointmentAvailable, providerId } = this.props;
    if (prevProps.providerId !== providerId) {
      // console.log('nextAppointmentAvailable', nextAppointmentAvailable)
      const currentMonth =
        reschedulingAppointment && reschedulingAppointment.date
          ? moment(`${reschedulingAppointment.date} ${reschedulingAppointment.startTime}`, 'MM/DD/YYYY HH:mm')
          : nextAppointmentAvailable && nextAppointmentAvailable.length > 0
            ? moment(nextAppointmentAvailable[0].date, 'MM/DD/YYYY')
            : new Date();
      this.setState({ currentMonth });
      this.setState({ selectedDate: reschedulingAppointment && reschedulingAppointment.date ? reschedulingAppointment.date : new Date() });
      // this.state = {
      //   currentMonth:
      //     reschedulingAppointment && reschedulingAppointment.date
      //       ? moment(`${reschedulingAppointment.date} ${reschedulingAppointment.startTime}`, 'MM/DD/YYYY HH:mm')
      //       : nextAppointmentAvailable && nextAppointmentAvailable.length > 0
      //         ? moment(nextAppointmentAvailable[0].date, 'MM/DD/YYYY')
      //         : new Date(),
      //   selectedDate: reschedulingAppointment && reschedulingAppointment.date ? reschedulingAppointment.date : new Date(),
      // };
    }
  }

  render() {
    const { currentMonth, selectedDate } = this.state;
    const { providerId, enforceDepartmentId, canWaitlist, showAddWaitlist, isMeno, nextAppointmentAvailable, hasLabs, isWeightLoss } = this.props;

    if (!providerId) return null;
    return (
      <Query
        query={OPEN_SLOTS}
        fetchPolicy="cache-and-network"
        variables={{
          startDate: moment(currentMonth)
            .startOf('month')
            .format('MM/DD/YYYY'),
          endDate: moment(currentMonth)
            .endOf('month')
            .format('MM/DD/YYYY'),
          enforceProviderId: providerId.toString(),
          enforceDepartmentId: enforceDepartmentId,
          isMeno: isMeno,
          force30: isMeno && hasLabs,
          isWeightLoss: isWeightLoss,
        }}
      >
        {({ loading, error, data }) => {
          return (
            <>
              <div className="calendar">
                {this.renderHeader()}
                {this.renderDays()}

                {this.renderCells(
                  data,
                  loading,
                  error,
                  selectedDate,
                  !nextAppointmentAvailable ||
                    nextAppointmentAvailable.length < 1 ||
                    (!!currentMonth && !!nextAppointmentAvailable[0].date && moment(currentMonth).isBefore(moment(nextAppointmentAvailable[0].date, 'MM/DD/YYYY'), 'month')),
                )}
                {!nextAppointmentAvailable || nextAppointmentAvailable.length < 1 ? (
                  <Flex justifyContent={'center'} alignItems={'center'} style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, background: 'rgba(255,255,255,0.75' }}>
                    <Text fontWeight={500} textAlign={'center'}>
                      No opening
                      <br />
                      available
                    </Text>
                  </Flex>
                ) : (
                  <>
                    {!!currentMonth &&
                      !!nextAppointmentAvailable[0].date &&
                      moment(currentMonth).isBefore(moment(nextAppointmentAvailable[0].date, 'MM/DD/YYYY'), 'month') && (
                        <Flex justifyContent={'center'} alignItems={'center'} style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, background: 'rgba(255,255,255,0.75' }}>
                          <Card
                            style={{ maxWidth: 'fit-content', cursor: 'pointer', padding: '8px 12px' }}
                            onClick={() => {
                              this.setState({ currentMonth: nextAppointmentAvailable[0].date });
                            }}
                          >
                            <Text style={{ fontSize: '13px' }} fontWeight={300} textAlign={'center'}>
                              Next availability on{' '}
                              <span style={{ fontWeight: 500 }}>
                                {moment(nextAppointmentAvailable[0].date, 'MM/DD/YYYY').format('MMM. Do')} {'>'}
                              </span>
                            </Text>
                          </Card>
                        </Flex>
                      )}
                  </>
                )}
              </div>

              {(!this.props || !this.props.isNotRegisteredFlow) &&
                !loading &&
                data &&
                !!canWaitlist && (
                  <Query
                    query={CAN_WAITLIST}
                    fetchPolicy="cache-and-network"
                    variables={{
                      startDate: moment(currentMonth)
                        .startOf('month')
                        .format('MM/DD/YYYY'),
                      endDate: moment(currentMonth)
                        .endOf('month')
                        .format('MM/DD/YYYY'),
                      enforceProviderId: providerId.toString(),
                      enforceDepartmentId: enforceDepartmentId,
                      isMeno: isMeno,
                      force30: isMeno && hasLabs,
                      isWeightLoss: isWeightLoss,
                    }}
                  >
                    {({ loading: loadingWaitlist, data: dataWaitlist }) => {
                      return (
                        <>
                          {!loadingWaitlist &&
                            !!canWaitlist &&
                            showAddWaitlist && (
                              <Flex justifyContent="center" mt={3}>
                                <Text style={{ textDecoration: 'underline', cursor: 'pointer', color: '#007CD6' }} onClick={() => showAddWaitlist(!!dataWaitlist.canWaitlist ? 15 : 30)}>
                                  Add me to the waitlist
                                </Text>
                              </Flex>
                            )}
                        </>
                      );
                    }}
                  </Query>
                )}
            </>
          );
        }}
      </Query>
    );
  }
}
const CalendarGridWithLabs = ({ labsData, ...props }) => {
  const [text, setText] = useState();
  const [labs, setLabs] = useState();
  useEffect(() => {
    if (!!labsData && labsData.labs) {
      for (let index = 0; index < labsData.labs.length; index++) {
        const element = labsData.labs[index];
        if (element.status === 'scannedByLab') {
          if ((element.currentStep || {}).eta) {
            const eta = momentTimezone((element.currentStep || {}).eta, 'YYYY-MM-DD').format('MM/DD/YYYY');
            setText(`Kit results expected by ${eta}. Please arrange your visit after this date.`);
            return;
          }
        }
      }
    }
  }, []);
  useEffect(
    () => {
      if (!!labsData && labsData.labs) {
        for (let index = 0; index < labsData.labs.length; index++) {
          const element = labsData.labs[index];
          if (element.status === 'scannedByLab') {
            if ((element.currentStep || {}).eta) {
              const eta = momentTimezone((element.currentStep || {}).eta, 'YYYY-MM-DD').format('MM/DD/YYYY');
              setText(`Kit results expected by ${eta}. Please arrange your visit after this date.`);
              return;
            }
          }
        }
      }
    },
    [labsData],
  );
  return (
    <Flex flexDirection={'column'}>
      {!!text && <Text>{text}</Text>}
      <CalendarGrid {...props} />
    </Flex>
  );
};

const CalendarGridWrap = (props) => {
  if (props.isNotRegisteredFlow) {
    return <CalendarGrid {...props} />;
  }
  return (
    <Query query={LABS}>
      {({ data: labsData, loading: labsLoading }) => {
        if (!!labsLoading) {
          return <PleaseWait />;
        }
        return <CalendarGridWithLabs labsData={labsData} {...props} />;
      }}
    </Query>
  );
};

export default CalendarGridWrap;
